import { getMarques } from "@/api/filters"
export default {
  state: {
    data: {}
  },
  mutations: {
    GET_MARQUES: (state, marques) => {
      state.data = marques
    }
  },
  actions: {
    getMarques({ commit }) {
      getMarques().then(response => {
        const marques = {
          placeholder: "Marques",
          trackBy: "id",
          options: response
        }
        commit("GET_MARQUES", marques)
      })
    }
  }
}
